// Access Token 仅保存在当前页面运行时内存中。
// Refresh Token 由后端写入 HttpOnly Cookie，前端 JavaScript 不可读取。
const LEGACY_TOKEN_KEYS = ['token_key', 'refresh_token_key']
let accessToken = ''

function clearLegacyStoredTokens () {
  if (typeof window === 'undefined' || !window.localStorage) {
    return
  }
  LEGACY_TOKEN_KEYS.forEach((key) => window.localStorage.removeItem(key))
}

function setToken (token) {
  accessToken = token || ''
  return accessToken
}

function getToken () {
  return accessToken
}

function removeToken () {
  accessToken = ''
}

clearLegacyStoredTokens()

export {
  setToken,
  getToken,
  removeToken,
  clearLegacyStoredTokens
}
